import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, from, throwError } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

export interface UserRole {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'client';
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = '/api/users';
  private inviteUrl = '/api/users/invite';

  constructor(private http: HttpClient, private auth: AuthService) {}

  /** Fetch all users from Cosmos via backend */
  getAllUsers(): Observable<UserRole[]> {
    console.log('Fetching users via Azure Function /api/users...');

    return this.http.get<any[]>(this.apiUrl).pipe(
      map(users =>
        users.map(u => ({
          id: u.id || u.user_id,
          name: u.name || u.nickname || u.email,
          email: u.email,
          role: (u.role === 'admin' ? 'admin' : 'client') as 'admin' | 'client'
        }))
      ),
      catchError(err => {
        console.error('Error fetching users from Azure Function:', err);
        return throwError(() => new Error('Failed to fetch users'));
      })
    );
  }

  /** Invite a new user (admin flow) via backend /api/users/invite */
  inviteUser(payload: { accountId: string; email: string; name?: string; role?: string; inviter?: string }): Observable<any> {
    console.log('Inviting user via /api/users/invite...');

    return from(
      this.auth.getAccessTokenSilently({
        authorizationParams: {
          audience: 'https://bouncd.us.auth0.com/api/v2/' // must match your Auth0 API audience
        }
      })
    ).pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        });
        return this.http.post(this.inviteUrl, payload, { headers });
      }),
      catchError(err => {
        console.error('Error inviting user via backend:', err);
        return throwError(() => new Error('User invite failed'));
      })
    );
  }
}